import { UserRole } from '../auth/types'
import { GetAllParams, PaginatedResponse } from '../types'

export type OwnerData = {
  company_name?: string | null
  vat_number?: string
  license?: string | null
  id_document?: string | null
  paypal_email?: string | null
  bank_account?: string | null
  availability_hours?: string | null
  law_431_98?: boolean | null
  billing_address?: string | null
  billing_zip?: string | null
  billing_city?: string | null
  billing_province?: string | null
  billing_country?: string | null
  fiscal_code?: string | null
  sdi_code?: string | null
  pec_email?: string | null
}

export type StudentData = {
  student_type?: number | null
  managed_profile?: boolean
  country_id?: number | null
  university_id?: number | null
  university_name?: string | null
  course_id?: number | null
  course_name?: string | null
  reference_office?: string | null
  contact_person?: string | null
  contact_email?: string | null
  contact_phone?: string | null
  special_needs?: string | null
  campus_id?: number | null
  department?: string | null
  first_year?: boolean | null
}

export type UserBase = {
  first_name: string | null
  last_name: string | null
  email: string
  active?: boolean | null
  email_verified_at?: string | null
}

export type UserProfileData = {
  gender?: 0 | 1 | null
  date_of_birth?: string | null
  place_of_birth?: string | null
  country_of_birth?: string | null
  nationality?: string
  referral_source?: string | null
  phone?: string | null
  mobile_phone?: string | null
  locale?: 'en' | 'es' | 'fr' | 'de' | 'it' | 'pt' | null
  avatar_url?: string | null
  owner_data?: OwnerData | null
  student_data?: StudentData | null
}

export type UserTimestamps = {
  created_at: string
  updated_at: string
}

export type UserPlan = 'pro' | 'safe' | 'suits'

export const USER_PLAN_PREFIX = 'plans:'

export type User = UserBase &
  UserProfileData &
  UserTimestamps & {
    id: number
    roles: UserRole[]
    capabilities?: string[] | null
    deleted_at?: string | null
  }

export type UserRoleName = UserRole['name']

export type CreateUserSchema = UserBase & {
  roles: UserRoleName[]
  capabilities?: string[] | null
  gender?: 0 | 1 | null
  nationality?: 0 | 1 | null
  referral_source?: string | null
  place_of_birth?: string | null
  country_of_birth?: string | null
  email_verified?: boolean
  owner_data?: OwnerData
  student_data?: StudentData
}

export type UpdateUserSchema = Partial<CreateUserSchema>

export type UsersResponse = PaginatedResponse<User>

export type UsersOrderBy = 'created_at' | '-created_at'

export interface UsersParams extends GetAllParams<UsersOrderBy> {
  role?: UserRoleName
  first_name?: string
  last_name?: string
  email?: string
  active?: boolean
  vat_number?: string
  trashed?: boolean
}
